import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { CabinetReport } from 'projects/app-misc/src/app/modules/reports/data/cabinet-report';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

@JsonObject('CabsProjReport')
export class CabsProjReport extends AbstractModel {
  @JsonProperty([CabinetReport], 'cabinets')
  cabinets: CabinetReport[];

  @JsonProperty(ShortProject, 'project')
  project: ShortProject;

  @JsonProperty(Number, 'overallComplexity')
  overallComplexity: number;
}

@JsonObject('CabinetsReportPage')
export class CabinetsReportPage extends ResponcePage {

  @JsonProperty([CabsProjReport], 'content')
  content: CabsProjReport[];
}
